import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import axios from "axios";
import {toast} from "react-toastify";

const ArchiveInstallationModal = (props) => {
    const {
        show            = false,
        parentId        = "",
        disabled        = false,
        onCancel        = () => { },
        onComplete      = (installation) => { },
        jobId           = null,
        orderId         = null,
        installationId  = null,
        id              = "archive-installation-modal",
    } = props;

    const [submitting, setSubmitting]       = useState(false);
    const [job, setJob]                     = useState(null);
    const [installation, setInstallation]   = useState(null);

    useEffect(() => {
        if (!!jobId && !!orderId && !!installationId) {
            load();
        }
    }, [jobId, orderId, installationId]);

    const load = () => {
        axios.get(route('web-api.job.order.installation.config', {job: jobId, order: orderId, installation_id: installationId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.installation) {
                        setInstallation(response.data.installation);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        axios.delete(route('web-api.job.order.installation.destroy', {
            job:            jobId,
            order:          orderId,
            installation:   installationId,
        }).toString())
            .then((response) => {
                setSubmitting(false);
                onComplete(installationId);
            })
            .catch((error) => {
                console.log(error);
                setSubmitting(false);
            });
    }

    const handleClose = () => {
        onCancel();
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleClose()}
            contentLabel="Delete Installation"
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">Delete Installation</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClose()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <p className="mb-3">
                        Are you sure you want to <b className="text-danger">delete</b> this installation:
                    </p>
                    {!!job && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Job Name</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!job.name ? job.name : ""}</p>
                            </div>
                        </React.Fragment>
                    )}
                    {!!installation && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Start Date</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!installation.start_at_display ? installation.start_at_display : "-"}</p>
                            </div>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>End Date</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!installation.end_at_display ? installation.end_at_display : "-"}</p>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="submit"
                        className="btn btn-danger py-0 px-3 ml-0 py-0 mr-4"
                        onClick={() => setSubmitting(true)}
                        disabled={submitting || disabled}
                    >
                        {"Yes, Delete Installation"}
                    </button>
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => handleClose()}
                    >
                        {"Cancel"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ArchiveInstallationModal;
